import React from "react";
import ReactGA from "react-ga";
//MUI Components
import Container from '@mui/material/Container';
import { Box, Typography } from "@mui/material";
import { useEffect } from "react";
function Footer(props){
        //analytics
        useEffect(()=>{
            ReactGA.pageview(window.location.pathname);
        },[])
    return(
        <Box sx={{marginTop:'4rem',backgroundColor:'#121212',color:'#ffffff',width:'100%',marginBottom:'0.5rem'}}>
            <Typography variant="overline" display="block" sx={{color:'#4EFBD7',textAlign:'center',letterSpacing:'0.1rem'}}>Developed By: DSC Web Dev Dept. | <a target="_blank" href="https://www.linkedin.com/in/kaifur-rahman/" style={{textDecoration:'none',display:'inline'}}><Typography sx={{textDecoration:'none',color:'#4EFBD7',fontSize:'0.8rem',letterSpacing:'0.1rem',display:'inline'}}>Kaifur Rahman</Typography></a> </Typography>
        </Box>
    )
}
export default Footer;